import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';

export const FormToggle = ({ id, label, checked, onChange, className, ...rest }) => {
  const displayLabel = label
    ? `${label} ${checked ? 'On' : 'Off'}`
    : checked ? 'On' : 'Off';

  return (
    <FormControlLabel
      id={id}
      className={`mss__toggle ${className ?? ''}`}
      control={
        <Switch
          id={id ? `${id}__switch` : undefined}
          checked={checked}
          onChange={onChange}
          {...rest}
        />
      }
      label={displayLabel}
    />
  );
};
